const state = {
  list: [],
  selectedDomain: null,
};

const getters = {
  mspDomainList: (state) => state.list,
  selectedMSPDomain: (state) => state.selectedDomain,
};

const actions = {
  async fetchMSPDomainListEntry(
    { commit },
    { id, policyId, action, domainId }
  ) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/${action}/${domainId}?msp_id=${id}`
    );

    commit("setSelectedListEntry", response.data);
  },

  async fetchMSPDomainList({ commit }, { id, policyId = "default" }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/all?msp_id=${id}`
    );

    commit("setMSPList", response.data.data);
  },

  async createMSPDomainListEntry({ commit }, { id, policyId, body, action }) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/${action}?msp_id=${id}`,
      body
    );
    commit("addListEntry", response.data);
    return response.data;
  },

  async updateMSPDomainListEntry(
    { commit },
    { id, policyId = "default", domainId, action, body }
  ) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/domains/${action}/${domainId}?msp_id=${id}`,
      body
    );

    const index = state.list.findIndex(
      (entry) => entry.id === response.data.id
    );

    if (index === -1) {
      commit("addListEntry", response.data);
    } else {
      commit("updateListEntry", {
        idx: index,
        locationAddress: response.data,
      });
    }

    commit("setSelectedListEntry", response.data);
  },
  // eslint-disable-next-line no-unused-vars
  async addBlockAllowedMsp({ _ }, { policyId, file, action, msp_id }) {
    let csv = new FormData();

    csv.append("csv", file);

    await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/import/${action}?overwrite=true&msp_id=${msp_id}`,
      csv,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  async deleteMSPDomainListEntrys({ commit }, { id, domains }) {
    const req = {};

    for (const domain of domains) {
      req[`${domain.id}`] = {
        method: "delete",
        path: `/policies/${
          domain.policyname === "Default" ? "default" : domain.policyid
        }/domains/${domain.object}/${domain.id}?msp_id=${id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteListEntry", ids);
  },
};

const mutations = {
  setMSPList: (state, data) => (state.list = data),
  setSelectedListEntry: (state, data) => (state.selectedDomain = data),
  addDomainListEntry: (state, data) => state.list.push(data),
  addListEntry: (state, data) => state.list.push(data),
  updateListEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  deleteListEntry(state, domains) {
    state.list = state.list.filter((domain) => !domains.includes(domain.id));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
